module.exports = __webpack_public_path__ + "img/solutions--safe_patient_handling.ea022700.png";